import React from "react";
// import { Typography } from "@material-tailwind/react";
 

export function FooterWithLogo() {
  return (
    

<footer class="bg-white rounded-lg shadow m-4 dark:bg-gray-800">
    <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center md:justify-end">
      <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">© 2024 <a href="https://www.instagram.com/rgusmiran/" class="hover:underline">MUHAMMAD RAYHAN GUSMIRAN</a>. SanberCode.
    </span>
    </div>
</footer>

  );
}

export default FooterWithLogo;